import '@/lib/fontawesome'
import labels from '@/lib/labels'
import { LanguageType } from '@/store/state'
import { Store, store } from '@/store/store'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// Needs special treatment
const iconThing: any = L.Icon.Default.prototype
delete iconThing._getIconUrl

L.Icon.Default.mergeOptions({
	iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
	iconUrl: require('leaflet/dist/images/marker-icon.png'),
	shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

// Make vuex store available typed as this.$tStore
declare module 'vue/types/vue' {
	interface Vue {
		$tStore: Store
		$lang: LanguageType
		$labels: { [key: string]: string }
	}
}

// Define typed store which points to vuex store but has correct type
Object.defineProperty(Vue.prototype, '$tStore', {
	get: function() {
		return this.$store as Store
	},
	enumerable: true
})

Object.defineProperty(Vue.prototype, '$lang', {
	get: function() {
		return this.$store.state.language
	}
})

Object.defineProperty(Vue.prototype, '$labels', {
	get: function() {
		return labels[this.$store.state.language as LanguageType]
	}
})

new Vue({
	render: h => h(App),
	store
}).$mount('#app')
